import { defineStore } from 'pinia'

export const useCoreStore = defineStore('core', {
    state: () => ({
        logoColor: 'white',
        sideMenuOpen: false,
        promotion: {},
    }),

    actions: {
        setLogoColor(newLogoColor) {
            this.logoColor = newLogoColor
        },
        setPromotion(newPromotion) {
            this.promotion = newPromotion
        },
        setSideMenuOpen(newSideMenuOpen) {
            this.sideMenuOpen = newSideMenuOpen
        }
    },
})
